import { Box, Spinner } from '@chakra-ui/react';

import styles from './styles.module.css';

const LoadMoreLoader = () => (
  <Box className={styles['load-more-loader__container']}>
    <Spinner color="var(--color-primary)" />
  </Box>
);

export default LoadMoreLoader;
